import classNames from 'classnames';
import React from 'react';
import RoomMessage from '../roomMessage';

type TMessageRoomsProps = {
  messages: Array<IRoomMessage> | undefined;
};

const RoomMessages = ({messages}: TMessageRoomsProps) => {
  return (
    <>
      {messages &&
        React.Children.toArray(
          messages
            ?.map(item => (
              <div
                className={classNames(
                  'd-flex',
                  item?.is_author
                    ? 'justify-content-start'
                    : 'justify-content-end',
                )}
              >
                <RoomMessage message={item} />
              </div>
            ))
            .reverse(),
        )}
    </>
  );
};

export default RoomMessages;
